import { createContext } from 'react';
export const PageContext = createContext<ArticleContextProps>({
	dimensions: null,
	name: '',
	setDimensions: () => {},
	hotspotMap: null,
	setHotspotMap: () => {},
	ctx: null,
	setCtx: () => {},
	onClickHotspot: () => {},
	page: 0,
});

export interface ArticleContextProps {
	containerRef?: any;
	name: string;
	page: number;
	dimensions: Dimensions | null;
	setDimensions: Function;
	hotspotMap: Map<string, Hotspot> | null;
	setHotspotMap: Function;
	ctx: CanvasRenderingContext2D | null;
	setCtx: Function;
	onClickHotspot(hotspot: Hotspot): void;
}

export interface Dimensions {
	width: number;
	height: number;
}

export interface Hotspot {
	url?: string;
	type?: string;
	area: Area;
}

export interface Area {
	x: number;
	y: number;
	width: number;
	height: number;
}
